import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import siteData from "../data/siteData.json";

function News() {
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;

    const form = document.getElementById("newsletterForm");
    if (!form) return undefined;

    const handleSubmit = (e) => {
      e.preventDefault();
      alert("Thank you for subscribing to our newsletter!");
      e.currentTarget.reset();
    };

    form.addEventListener("submit", handleSubmit);
    return () => form.removeEventListener("submit", handleSubmit);
  }, []);

  const { news } = siteData;
  const midPress = Math.ceil(news.pressReleases.length / 2);

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={siteData.heroBanner} className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>

      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>NEWS & UPDATES</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="news-section">
        <div className="container">
          <div className="featured-news">
            <div className="row g-0">
              <div className="col-lg-6">
                <div className="news-image">
                  <img src={news.featured.image} alt="Featured News" />
                  <span className="news-category">{news.featured.category}</span>
                  <span className="award-badge">
                    <i className="fa fa-trophy"></i> {news.featured.awardBadge}
                  </span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="news-content">
                  <div className="news-date">
                    <i className="fa fa-calendar"></i> {news.featured.date}
                  </div>
                  <h3 className="news-title">
                    <a href={news.featured.href}>{news.featured.title}</a>
                  </h3>
                  <p className="news-excerpt">{news.featured.excerpt}</p>
                  <a href="#" className="news-read-more">
                    Read More <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {news.items.map((item) => (
              <div className="col-lg-4 col-md-6 mb-4" key={item.title}>
                <div className="news-card">
                  <div className="news-image">
                    <img src={item.image} alt="News" />
                    <span className="news-category">{item.category}</span>
                  </div>
                  <div className="news-content">
                    <div className="news-date">
                      <i className="fa fa-calendar"></i> {item.date}
                    </div>
                    <h3 className="news-title">
                      <a href={item.href}>{item.title}</a>
                    </h3>
                    <p className="news-excerpt">{item.excerpt}</p>
                    <a href="#" className="news-read-more">
                      Read More <i className="fa fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row mt-5">
            <div className="col-md-12">
              <div className="title mb-4">
                <h2>Press Releases</h2>
              </div>
            </div>
            <div className="col-md-6">
              {news.pressReleases.slice(0, midPress).map((release) => (
                <div className="press-release-card" key={release.title}>
                  <div className="date">
                    <i className="fa fa-clock-o"></i> {release.date}
                  </div>
                  <h4>{release.title}</h4>
                  <a href="#" className="news-read-more">
                    Read Press Release <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              ))}
            </div>
            <div className="col-md-6">
              {news.pressReleases.slice(midPress).map((release) => (
                <div className="press-release-card" key={release.title}>
                  <div className="date">
                    <i className="fa fa-clock-o"></i> {release.date}
                  </div>
                  <h4>{release.title}</h4>
                  <a href="#" className="news-read-more">
                    Read Press Release <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="newsletter-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2>{news.newsletter.title}</h2>
              <p>{news.newsletter.text}</p>
            </div>
            <div className="col-lg-6">
              <form className="newsletter-form" id="newsletterForm">
                <input type="email" placeholder={news.newsletter.placeholder} required />
                <button type="submit">{news.newsletter.button}</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default News;